import React from "react";
import iconPause from "../../assets/icon/ic_pause.svg";
import iconPlay from "../../assets/icon/ic_play_sm.svg";
import styled from "styled-components";

const StyledPlayButton = styled.div`
    height: 100%;
    cursor: pointer;
    
    display: inline-block;
    width: 68px;
    height: 60px;
    background-color: ${(props) => (props as any)['data-play'] ? "#615EFF" : "#E03F32"};
    position: relative;
    
    img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    
    :hover {
        background-color: ${(props) => (props as any)['data-play'] ? "#3E3AFF" : "#C6281C"};
    }
`;

interface IPlayButtonSM {
    isPlaying: boolean
}

const PlayButtonSM: React.FC<IPlayButtonSM> = (({isPlaying}) => {
    return (
        <StyledPlayButton data-play={isPlaying}>
            <img src={isPlaying ? iconPlay : iconPause} alt=""/>
        </StyledPlayButton>
    )
});

export default PlayButtonSM;